/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import ExamQuestion from './ExamQuestion';
import ExamTimer from './ExamTimer';
import { useSubmitExamQuestion, useValidateExam } from '../examsQueries';
import { BaseContentControlWrapper } from '../../../components/ContentControlWrapper';
import QuizTopbar from '../../../components/QuizTopbar';
import { useCallback, useEffect, useState } from 'react';
import { useMostRecentExamAttempt } from '../examsQueries';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import ExamLoadingScreen from './ExamLoadingScreen';
import { useFullTrack } from '../../tracks';
import UsageTracker from '../../../utils/UsageTracker';
import { Metrics } from '../../../Metrics';
import { QuizWrapper } from './QuizWrapper';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExamQuestionScreen = ({
  trackId,
  language,
  clientStartTime
}) => {
  const [selectedAnswerIds, setSelectedAnswerIds] = useState([]);
  const {
    track,
    trackLoading
  } = useFullTrack(trackId, language);
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading
  } = useMostRecentExamAttempt(trackId, language);
  const [submitExamQuestion, {
    submitExamQuestionLoading,
    submitExamQuestionError
  }] = useSubmitExamQuestion();
  const [validateExam, {
    validateExamLoading,
    validateExamError
  }] = useValidateExam(Number(trackId), language);
  const totalQuestionCount = mostRecentExamAttempt ? mostRecentExamAttempt.questions.length : 0;
  const currentQuestionIndex = mostRecentExamAttempt ? Math.max(0, Math.min(mostRecentExamAttempt.questionSubmissions.length, totalQuestionCount - 1)) : 0;
  const currentQuestion = mostRecentExamAttempt && mostRecentExamAttempt.questions[currentQuestionIndex];
  const isLastQuestion = currentQuestionIndex + 1 >= totalQuestionCount;
  const handleClickNext = useCallback(() => {
    if (!currentQuestion || !selectedAnswerIds.length) return null;
    return submitExamQuestion(trackId, mostRecentExamAttempt.id, currentQuestion.id, selectedAnswerIds).then(() => {
      setSelectedAnswerIds([]);
      Metrics.counter('exam-question-answered', {
        lannguae: mostRecentExamAttempt.language
      }).increment();
      if (isLastQuestion) {
        return validateExam(mostRecentExamAttempt.id).then(() => {
          UsageTracker.track('examInteraction', {
            action: 'completed',
            examId: track && track.exam.id,
            examLength: mostRecentExamAttempt.questions.length,
            trackId: trackId && trackId.toString(),
            trackName: track && track.name,
            examAttemptId: mostRecentExamAttempt.id && mostRecentExamAttempt.id.toString(),
            language: mostRecentExamAttempt.language
          });
          Metrics.counter('exam-completed', {
            language: mostRecentExamAttempt.language
          }).increment();
        });
      }
      const completionPercentage = +((currentQuestionIndex + 1 / totalQuestionCount) * 100).toFixed(2);
      UsageTracker.track('examInteraction', {
        action: 'progress',
        examId: track && track.exam.id,
        examLength: mostRecentExamAttempt.questions.length,
        trackId: trackId && trackId.toString(),
        trackName: track && track.name,
        examAttemptId: mostRecentExamAttempt.id && mostRecentExamAttempt.id.toString(),
        completionPercentage,
        language: mostRecentExamAttempt.language
      });
      return null;
    });
  }, [currentQuestion, currentQuestionIndex, isLastQuestion, mostRecentExamAttempt, selectedAnswerIds, submitExamQuestion, totalQuestionCount, track, trackId, validateExam]);
  useEffect(() => {
    const handleKeydown = event => {
      if (event.key === 'Enter' && selectedAnswerIds.length && !(submitExamQuestionLoading || validateExamLoading)) {
        handleClickNext();
      }
    };
    document.addEventListener('keydown', handleKeydown);
    return () => document.removeEventListener('keydown', handleKeydown);
  }, [currentQuestionIndex, handleClickNext, selectedAnswerIds.length, submitExamQuestionLoading, validateExamLoading]);
  if (mostRecentExamAttemptLoading || trackLoading) return /*#__PURE__*/_jsx(ExamLoadingScreen, {});
  if (!mostRecentExamAttempt || !currentQuestion || !track) return null;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(QuizWrapper, {
      children: [/*#__PURE__*/_jsx(QuizTopbar, {
        currentQuestion: currentQuestionIndex + 1,
        numQuestions: totalQuestionCount,
        topRightComponent: /*#__PURE__*/_jsx(ExamTimer, {
          clientStartTime: clientStartTime,
          language: language,
          trackId: trackId
        })
      }), /*#__PURE__*/_jsxs(View, {
        inlineSize: "100%",
        paddingBlockStart: "500",
        children: [/*#__PURE__*/_jsx("h2", {
          children: currentQuestion.question
        }), /*#__PURE__*/_jsx(ExamQuestion, {
          language: language,
          onSelectAnswer: setSelectedAnswerIds,
          selectedAnswerIds: selectedAnswerIds,
          trackId: trackId
        })]
      })]
    }), /*#__PURE__*/_jsx(BaseContentControlWrapper, {
      children: /*#__PURE__*/_jsx(LoadingButton, {
        "data-test-id": "exam-next-question-button",
        disabled: selectedAnswerIds.length <= 0,
        failed: !!submitExamQuestionError || !!validateExamError,
        loading: submitExamQuestionLoading || validateExamLoading,
        onClick: handleClickNext,
        preventClicksOnLoading: submitExamQuestionLoading || validateExamLoading,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.exams.examQuestion.nextButton"
        })
      })
    })]
  });
};
export default ExamQuestionScreen;